<template>
    <ui-modal :title="title" :close="() => { close(); afterClose?afterClose():null; }">
        <template #icon>
            <div
                class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                <i class="far fa-address-card mr-4 text-blue-500 ml-4"></i>
            </div>
        </template>
        <div>
            <ui-textarea autoresize name="description" placeholder="What needs to be done?"
                         v-model="description"></ui-textarea>
        </div>
        <template #footer-primary>
            <span class="mt-0 flex w-full sm:mt-0 sm:w-auto">
                <ui-button-new primary class="w-full whitespace-nowrap" :loading="form.busy" @click="form.submit()"
                               v-text="button"></ui-button-new>
            </span>
        </template>
    </ui-modal>
</template>

<script>

import UiModal from "../../../../ui/UiModal.vue";
import UiButtonNew from "../../../../ui/UiButtonNew.vue";
import UiInput from "../../../../ui/UiInput.vue";

export default {
    components: {UiInput, UiButtonNew, UiModal},
    props: {
        handle: Function,
        close: Function,
        afterClose: Function,
        title: {
            type: String,
            default: 'Add Date'
        },
        button: {
            type: String,
            default: 'Add Date'
        },
        name: '',
        contacts: {}
    },
    data() {
        return {
            description: '',
            form: new Form({}, async (form) => {
                await this.handle(form, this);
                this.close();
            }),
        }
    },
    methods: {}
}
</script>
